// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dpu-loader {
  width: 50px;
  height: 50px;
  position: absolute;
  z-index: 100;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}
.dpu-loader::after,
.dpu-loader::before {
  content: "";
  box-sizing: border-box;
  width: 50px;
  height: 50px;
  position: absolute;
  opacity: 0.25;
  left: 0;
  top: 0;
}
.dpu-loader::before {
  border: 3px solid rgba(0, 123, 85, 0.24);
  animation: rotation 3.2s ease-in-out infinite alternate;
}
.dpu-loader::after {
  border: 8px solid rgba(0, 123, 85, 0.24);
  animation-direction: alternate-reverse;
  animation: rotationAfter 3.2s ease-in-out infinite alternate;
}

.dpu-logo {
  width: 50px;
  height: 50px;
  animation: scaleOpacityAnimation 3.2s linear infinite;
}

@keyframes rotation {
  0% {
    transform: scale(1.6) rotate(270deg);
    opacity: 0.25;
    border-radius: 25%;
  }

  25% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
    border-radius: 25%;
  }

  50% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
    border-radius: 50%;
  }

  75% {
    transform: scale(1.6) rotate(270deg);
    opacity: 1;
    border-radius: 50%;
  }

  100% {
    transform: scale(1.6) rotate(270deg);
    opacity: 0.25;
    border-radius: 25%;
  }
}

@keyframes rotationAfter {
  0% {
    transform: scale(1.2) rotate(0deg);
    opacity: 0.25;
    border-radius: 25%;
  }

  25% {
    transform: scale(1) rotate(270deg);
    opacity: 1;
    border-radius: 25%;
  }

  50% {
    transform: scale(1) rotate(270deg);
    opacity: 1;
    border-radius: 50%;
  }

  75% {
    transform: scale(1.2) rotate(0deg);
    opacity: 1;
    border-radius: 50%;
  }

  100% {
    transform: scale(1.2) rotate(0deg);
    opacity: 0.25;
    border-radius: 25%;
  }
}

@keyframes scaleOpacityAnimation {
  0% {
    transform: scale(0.78);
    opacity: 1;
  }

  25% {
    transform: scale(0.7);
    opacity: 0.48;
  }

  50% {
    transform: scale(0.7);
    opacity: 0.48;
  }

  75% {
    transform: scale(0.78);
    opacity: 1;
  }

  100% {
    transform: scale(0.78);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Loading/loading.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,QAAQ;EACR,SAAS;AACX;AACA;;EAEE,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,MAAM;AACR;AACA;EACE,wCAAwC;EACxC,uDAAuD;AACzD;AACA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE;IACE,oCAAoC;IACpC,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;IAChC,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;IAChC,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF","sourcesContent":[".dpu-loader {\r\n  width: 50px;\r\n  height: 50px;\r\n  position: absolute;\r\n  z-index: 100;\r\n  transform: translate(-50%, -50%);\r\n  top: 50%;\r\n  left: 50%;\r\n}\r\n.dpu-loader::after,\r\n.dpu-loader::before {\r\n  content: \"\";\r\n  box-sizing: border-box;\r\n  width: 50px;\r\n  height: 50px;\r\n  position: absolute;\r\n  opacity: 0.25;\r\n  left: 0;\r\n  top: 0;\r\n}\r\n.dpu-loader::before {\r\n  border: 3px solid rgba(0, 123, 85, 0.24);\r\n  animation: rotation 3.2s ease-in-out infinite alternate;\r\n}\r\n.dpu-loader::after {\r\n  border: 8px solid rgba(0, 123, 85, 0.24);\r\n  animation-direction: alternate-reverse;\r\n  animation: rotationAfter 3.2s ease-in-out infinite alternate;\r\n}\r\n\r\n.dpu-logo {\r\n  width: 50px;\r\n  height: 50px;\r\n  animation: scaleOpacityAnimation 3.2s linear infinite;\r\n}\r\n\r\n@keyframes rotation {\r\n  0% {\r\n    transform: scale(1.6) rotate(270deg);\r\n    opacity: 0.25;\r\n    border-radius: 25%;\r\n  }\r\n\r\n  25% {\r\n    transform: scale(1) rotate(0deg);\r\n    opacity: 1;\r\n    border-radius: 25%;\r\n  }\r\n\r\n  50% {\r\n    transform: scale(1) rotate(0deg);\r\n    opacity: 1;\r\n    border-radius: 50%;\r\n  }\r\n\r\n  75% {\r\n    transform: scale(1.6) rotate(270deg);\r\n    opacity: 1;\r\n    border-radius: 50%;\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1.6) rotate(270deg);\r\n    opacity: 0.25;\r\n    border-radius: 25%;\r\n  }\r\n}\r\n\r\n@keyframes rotationAfter {\r\n  0% {\r\n    transform: scale(1.2) rotate(0deg);\r\n    opacity: 0.25;\r\n    border-radius: 25%;\r\n  }\r\n\r\n  25% {\r\n    transform: scale(1) rotate(270deg);\r\n    opacity: 1;\r\n    border-radius: 25%;\r\n  }\r\n\r\n  50% {\r\n    transform: scale(1) rotate(270deg);\r\n    opacity: 1;\r\n    border-radius: 50%;\r\n  }\r\n\r\n  75% {\r\n    transform: scale(1.2) rotate(0deg);\r\n    opacity: 1;\r\n    border-radius: 50%;\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1.2) rotate(0deg);\r\n    opacity: 0.25;\r\n    border-radius: 25%;\r\n  }\r\n}\r\n\r\n@keyframes scaleOpacityAnimation {\r\n  0% {\r\n    transform: scale(0.78);\r\n    opacity: 1;\r\n  }\r\n\r\n  25% {\r\n    transform: scale(0.7);\r\n    opacity: 0.48;\r\n  }\r\n\r\n  50% {\r\n    transform: scale(0.7);\r\n    opacity: 0.48;\r\n  }\r\n\r\n  75% {\r\n    transform: scale(0.78);\r\n    opacity: 1;\r\n  }\r\n\r\n  100% {\r\n    transform: scale(0.78);\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
